import { Injectable, Injector } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { AuthService } from './auth.service';
import { Analytics, isSupported, setUserId } from '@angular/fire/analytics';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private _analytics;
  constructor(
    private toastrService: NbToastrService,
    private router: Router,
    private injector: Injector,
    private authService: AuthService
  ) {
    isSupported().then((r) => {
      if (r) {
        this._analytics = this.injector.get(Analytics);
      }
    });
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.authService.getCurrentUser();
    const roles: string[] = await this.authService.getUserRoles();
    let isApprovedRole = false;
    const availRoles = this.authService.getCMSRoleOptions();
    roles.forEach((r) => {
      if (availRoles.indexOf(r) > -1) {
        isApprovedRole = true;
      }
    });
    const isLoggedIn = !!user && user.emailVerified && isApprovedRole;
    if (!isLoggedIn) {
      await this.router.navigate(['/auth']);
      this.toastrService.danger(
        'Unable to access',
        'Must be logged in to view this content. Make sure to verify your email address.',
        {
          destroyByClick: true,
          duration: 10000
        }
      );
      if (!isApprovedRole) {
        this.toastrService.warning('CMS Prohibited', 'Must be an admin to view this content', {
          destroyByClick: true,
          duration: 10000
        });
      }
    } else {
      if (this._analytics) {
        setUserId(this._analytics, user.uid);
      }
    }
    return isLoggedIn;
  }
}
